import formatCurrency from "@/utils/formatCurrency";

/** Formats a major-unit amount, dropping ".00" on whole amounts but keeping cents otherwise. */
export const formatHeadlineAmount = (amount: number, currency: string) =>
  formatCurrency(amount, currency, {
    minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
  });
